CropYear = App.loadClass "core::CropYear"

class exports.ChangesToSave
    constructor: () ->
        @clear()


    toAdd: () =>
        return _.difference @keyFields, @originalKeyFields


    toDelete: () =>
        return _.difference @originalKeyFields, @keyFields


    changesMade: () =>
        if @keyFields.length is 0 and @originalKeyFields.length is 0
            return false

        to_add = @toAdd()
        to_delete = @toDelete()

        return to_add.length > 0 or to_delete.length > 0


    # reset key fields to what they were originally
    reset: () =>
        @keyFields = _.clone @originalKeyFields


    # set original key fields to new key fields
    update: () =>
        @originalKeyFields = _.clone @keyFields


    # clear both new key fields and original
    clear: () =>
        @keyFields = []
        @originalKeyFields = []
